// class MaolisProduct extends HTMLElement{constructor(){super();this.isLoading=!1;this.productVariants=JSON.parse(this.querySelector("#MaolisProductVariants").textContent);this.productMessage=this.querySelector("[data-product-message]");this.slider=this.querySelector("[data-slider]");this.scrollbarThumb=this.querySelector("[data-thumb]");this.sliderControls=this.querySelectorAll("[data-control]");this.slides=this.slider.querySelectorAll(":scope > li");this.maxLength=this.slides.length;this.currentSlide=1;this.scrollEndTimer=null;if(this.slider&&this.sliderControls.length>0){this.updateScrollbar();this.slider.addEventListener("scroll",()=>{this.updateScrollbar();clearTimeout(this.scrollEndTimer);this.scrollEndTimer=setTimeout(()=>{this.updateScrollbar()},80)});window.addEventListener("resize",()=>{this.updateScrollbar()})}}
// connectedCallback(){this.setInitialVariantImage();this.initChangeEvent();this.initSubmitEvent();this.initClickEvent();this.updateScrollbar()}
// setInitialVariantImage(){
//   const variantIdInput = this.querySelector("input[name='id']");

//   if(!variantIdInput || !this.slider) return;

//   const currentVariantId = Number(variantIdInput.value);

//   const currentVariant = this.productVariants.find(
//     variant => Number(variant.id) === currentVariantId
//   );

//   if(!currentVariant || !currentVariant.featured_image) return;

//   const imageIndex = currentVariant.featured_image.position;

//   const slide = this.slider.querySelector(
//     `li[data-slide="${imageIndex}"]`
//   );

//   if(!slide) return;

//   this.slider.scrollLeft = slide.offsetLeft;
//   this.currentSlide = imageIndex;
// }
// variantChange(){this.toggleLoading();const searchParams=new URLSearchParams();let selectedValuesLabel="";[1,2,3].forEach((option)=>{if(this.querySelector(`[data-option="${option}"]`)){if(this.querySelector(`[data-option="${option}"] input:checked`)){selectedValuesLabel+=" / "+this.querySelector(`[data-option="${option}"] input:checked`).value}else{selectedValuesLabel+=" / "+this.querySelector(`[data-option="${option}"] input`).value}}});this.productVariants.forEach((variant)=>{if(variant.title===selectedValuesLabel.slice(3)){if(this.querySelector("input[name='id']")){this.querySelector("input[name='id']").value=variant.id}
// searchParams.set("variant",variant.id);if(variant.featured_image){const imageIndex=variant.featured_image.position;const slide=this.slider.querySelector(`li[data-slide="${imageIndex}"]`);if(slide){this.slider.scrollTo({left:slide.offsetLeft,behavior:"smooth",})}}}});const newProductUrl=window.location.origin+window.location.pathname+`?${searchParams.toString()}`;window.history.replaceState({},"",newProductUrl);fetch(newProductUrl).then((res)=>res.text()).then((body)=>{const html=new DOMParser().parseFromString(body,"text/html");const section=html.querySelector("maolis-product");const currentDataToUpdate=this.querySelectorAll("[updateable-data]");currentDataToUpdate.forEach((elementToUpdate)=>{const elementIndicator=elementToUpdate.getAttribute("updateable-data");if(section.querySelector(`[updateable-data="${elementIndicator}"]`)){elementToUpdate.innerHTML=section.querySelector(`[updateable-data="${elementIndicator}"]`).innerHTML}})}).catch((error)=>console.error(error)).finally(()=>this.toggleLoading())}
// addToCart(){this.toggleLoading();const cartData={items:[{id:parseInt(this.querySelector("[name='id']").value),quantity:parseInt(this.querySelector("[name='quantity']").value),},],};fetch(window.Shopify.routes.root+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",},body:JSON.stringify(cartData),}).then((response)=>response.json()).then((response)=>{if(!response.items){let error=new Error(response.description);throw error}else{if(this.productMessage)this.productMessage.innerHTML="";window.location.pathname="/cart"}}).catch((error)=>{if(this.productMessage){this.productMessage.innerHTML=error;setTimeout(()=>{this.productMessage.innerHTML=""},5000)}
// console.error(error)}).finally(()=>this.toggleLoading())}
// updateScrollbar(){if(!this.slider)return;const scrollWidth=this.slider.scrollWidth;const clientWidth=this.slider.clientWidth;if(!this.slides.length)return;const blockWidth=this.slides[0].offsetWidth+8;const scrollLeft=this.slider.scrollLeft;const thumbPosition=scrollLeft/(scrollWidth-clientWidth);const thumbWidth=clientWidth/scrollWidth;this.scrollbarThumb.style.left=`${thumbPosition * 100}%`;this.scrollbarThumb.style.width=`${thumbWidth * 100}%`;this.scrollbarThumb.style.transform=`translateX(-${thumbPosition * 100}%)`;this.currentSlide=Math.round(scrollLeft/blockWidth)+1;this.currentSlide=Math.max(1,Math.min(this.currentSlide,this.maxLength));this.sliderControls[0].classList.toggle("disabled",this.currentSlide<=1);this.sliderControls[1].classList.toggle("disabled",this.currentSlide>=this.maxLength);const thumbnails=this.querySelectorAll('.maolis-product__gallery-nav [data-trigger="select-media"]');thumbnails.forEach((thumbnail)=>{const isActive=Number(thumbnail.dataset.slide)===this.currentSlide;thumbnail.classList.toggle("active",isActive);if(isActive){thumbnail.scrollIntoView({behavior:"smooth",block:"nearest",inline:"nearest"})}})}
// initChangeEvent(){this.addEventListener("change",this.variantChange.bind(this))}
// initSubmitEvent(){this.addEventListener("submit",(e)=>{e.preventDefault();if(!this.isLoading){this.addToCart()}})}
// initClickEvent(){this.addEventListener("click",(e)=>{const trigger=e.target.closest("[data-trigger]");if(trigger){const quantityElement=this.querySelector("[name='quantity']");const currentQuantity=parseInt(quantityElement.value);console.log(currentQuantity);switch(e.target.dataset.trigger){case "quantity-decrease":if(!this.isLoading&&!e.target.classList.contains("disabled")&&currentQuantity>1){quantityElement.value=currentQuantity-1;this.querySelector('[data-trigger="quantity-decrease"]').classList.toggle("disabled",currentQuantity==1);this.querySelector('[data-trigger="quantity-increase"]').classList.toggle("disabled",currentQuantity==99)}
// break;case "quantity-increase":if(!this.isLoading&&!e.target.classList.contains("disabled")&&currentQuantity<99){quantityElement.value=currentQuantity+1;this.querySelector('[data-trigger="quantity-decrease"]').classList.toggle("disabled",currentQuantity==1);this.querySelector('[data-trigger="quantity-increase"]').classList.toggle("disabled",currentQuantity==99)}
// break;case "select-media":const targetSlide=this.slider.querySelector(`[data-slide="${trigger.dataset.slide}"]`);if(targetSlide){targetSlide.scrollIntoView({behavior:"smooth",block:"nearest",inline:"start"});requestAnimationFrame(()=>{this.updateScrollbar()})}
// break;case "disclosure":const tab=e.target.closest("[data-disclosure]");const disclosureContent=e.target.nextElementSibling;const wasOpen=tab.classList.contains("open");this.querySelectorAll("[data-disclosure].open").forEach((openTab)=>{if(openTab!==tab){openTab.classList.remove("open");const openContent=openTab.querySelector(".maolis-product__disclosure-content");if(openContent){openContent.style.maxHeight=null}}});tab.classList.toggle("open",!wasOpen);disclosureContent.style.maxHeight=!wasOpen?disclosureContent.scrollHeight+"px":null;break}}else if(e.target.hasAttribute("data-control")){const blockWidth=this.slides[0].offsetWidth+8;let newScrollLeft=this.slider.scrollLeft;if(e.target.dataset.control==="next"){newScrollLeft+=blockWidth}
// if(e.target.dataset.control==="prev"){newScrollLeft-=blockWidth}
// this.slider.scrollTo({left:newScrollLeft,behavior:"smooth",});requestAnimationFrame(()=>{clearTimeout(this.scrollEndTimer);this.scrollEndTimer=setTimeout(()=>{this.updateScrollbar()},300)})}})}
// toggleLoading(){this.isLoading=!this.isLoading;this.classList.toggle("loading",this.isLoading)}}
// customElements.define("maolis-product",MaolisProduct)




class MaolisProduct extends HTMLElement {
  constructor() {
    super();

    this.isLoading = false;

    this.productVariants = JSON.parse(
      this.querySelector("#MaolisProductVariants").textContent
    );

    this.productMessage = this.querySelector("[data-product-message]");
    this.slider = this.querySelector("[data-slider]");
    this.scrollbarThumb = this.querySelector("[data-thumb]");
    this.sliderControls = this.querySelectorAll("[data-control]");

    this.slides = this.slider
      ? this.slider.querySelectorAll(":scope > li")
      : [];

    this.maxLength = this.slides.length;
    this.currentSlide = 1;
    this.scrollEndTimer = null;

    if (this.slider && this.sliderControls.length > 0) {
      this.updateScrollbar();

      this.slider.addEventListener("scroll", () => {
        this.updateScrollbar();

        clearTimeout(this.scrollEndTimer);

        this.scrollEndTimer = setTimeout(() => {
          this.updateScrollbar();
        }, 80);
      });

      window.addEventListener("resize", () => {
        this.updateScrollbar();
      });
    }
  }

  connectedCallback() {
    // this.setInitialVariantImage();
    this.initChangeEvent();
    this.initSubmitEvent();
    this.initClickEvent();
    this.updateScrollbar();
  }

  setInitialVariantImage() {
    const variantIdInput = this.querySelector("input[name='id']");

    if (!variantIdInput || !this.slider) return;

    const currentVariantId = Number(variantIdInput.value);

    const currentVariant = this.productVariants.find(
      (variant) => Number(variant.id) === currentVariantId
    );

    if (!currentVariant || !currentVariant.featured_image) return;

    const imageIndex = currentVariant.featured_image.position;

    const slide = this.slider.querySelector(
      `li[data-slide="${imageIndex}"]`
    );

    if (!slide) return;

    this.slider.scrollLeft = slide.offsetLeft;
    this.currentSlide = imageIndex;
  }

  variantChange() {
    this.toggleLoading();

    const searchParams = new URLSearchParams();
    let selectedValuesLabel = "";

    [1, 2, 3].forEach((option) => {
      const optionElement = this.querySelector(
        `[data-option="${option}"]`
      );

      if (!optionElement) return;

      const checkedInput = optionElement.querySelector("input:checked");
      const fallbackInput = optionElement.querySelector("input");

      if (checkedInput) {
        selectedValuesLabel += " / " + checkedInput.value;
      } else if (fallbackInput) {
        selectedValuesLabel += " / " + fallbackInput.value;
      }
    });

    this.productVariants.forEach((variant) => {
      if (variant.title === selectedValuesLabel.slice(3)) {
        const variantInput = this.querySelector("input[name='id']");

        if (variantInput) {
          variantInput.value = variant.id;
        }

        searchParams.set("variant", variant.id);

        if (variant.featured_image && this.slider) {
          const imageIndex = variant.featured_image.position;

          const slide = this.slider.querySelector(
            `li[data-slide="${imageIndex}"]`
          );

          if (slide) {
            this.slider.scrollTo({
              left: slide.offsetLeft,
              behavior: "smooth",
            });
          }
        }
      }
    });

    const newProductUrl =
      window.location.origin +
      window.location.pathname +
      `?${searchParams.toString()}`;

    window.history.replaceState({}, "", newProductUrl);

    fetch(newProductUrl)
      .then((res) => res.text())
      .then((body) => {
        const html = new DOMParser().parseFromString(body, "text/html");

        const section = html.querySelector("maolis-product");

        if (!section) return;

        const currentDataToUpdate =
          this.querySelectorAll("[updateable-data]");

        currentDataToUpdate.forEach((elementToUpdate) => {
          const elementIndicator =
            elementToUpdate.getAttribute("updateable-data");

          const newElement = section.querySelector(
            `[updateable-data="${elementIndicator}"]`
          );

          if (newElement) {
            elementToUpdate.innerHTML = newElement.innerHTML;
          }
        });
      })
      .catch((error) => console.error(error))
      .finally(() => this.toggleLoading());
  }

  addToCart() {
    this.toggleLoading();

    const cartData = {
      items: [
        {
          id: parseInt(
            this.querySelector("[name='id']").value
          ),
          quantity: parseInt(
            this.querySelector("[name='quantity']").value
          ),
        },
      ],
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cartData),
    })
      .then((response) => response.json())
      .then((response) => {
        if (!response.items) {
          let error = new Error(response.description);
          throw error;
        }

        if (this.productMessage) {
          this.productMessage.innerHTML = "";
        }

        window.location.pathname = "/cart";
      })
      .catch((error) => {
        if (this.productMessage) {
          this.productMessage.innerHTML = error;

          setTimeout(() => {
            this.productMessage.innerHTML = "";
          }, 5000);
        }

        console.error(error);
      })
      .finally(() => this.toggleLoading());
  }

  updateScrollbar() {
    if (!this.slider) return;
    if (!this.slides.length) return;

    const scrollWidth = this.slider.scrollWidth;
    const clientWidth = this.slider.clientWidth;

    const blockWidth =
      this.slides[0].offsetWidth + 8;

    const scrollLeft = this.slider.scrollLeft;

    if (this.scrollbarThumb && scrollWidth > clientWidth) {
      const thumbPosition =
        scrollLeft / (scrollWidth - clientWidth);

      const thumbWidth =
        clientWidth / scrollWidth;

      this.scrollbarThumb.style.left =
        `${thumbPosition * 100}%`;

      this.scrollbarThumb.style.width =
        `${thumbWidth * 100}%`;

      this.scrollbarThumb.style.transform =
        `translateX(-${thumbPosition * 100}%)`;
    }

    this.currentSlide =
      Math.round(scrollLeft / blockWidth) + 1;

    this.currentSlide = Math.max(
      1,
      Math.min(this.currentSlide, this.maxLength)
    );

    if (this.sliderControls.length >= 2) {
      this.sliderControls[0].classList.toggle(
        "disabled",
        this.currentSlide <= 1
      );

      this.sliderControls[1].classList.toggle(
        "disabled",
        this.currentSlide >= this.maxLength
      );
    }

    const thumbnails = this.querySelectorAll(
      '.maolis-product__gallery-nav [data-trigger="select-media"]'
    );

    thumbnails.forEach((thumbnail) => {
      const isActive =
        Number(thumbnail.dataset.slide) ===
        this.currentSlide;

      thumbnail.classList.toggle("active", isActive);

      // IMPORTANT:
      // We deliberately do NOT use scrollIntoView here.
      // scrollIntoView can make the whole page move vertically.
    });
  }

  initChangeEvent() {
    this.addEventListener(
      "change",
      this.variantChange.bind(this)
    );
  }

  initSubmitEvent() {
    this.addEventListener("submit", (e) => {
      e.preventDefault();

      if (!this.isLoading) {
        this.addToCart();
      }
    });
  }

  initClickEvent() {
    this.addEventListener("click", (e) => {
      const trigger = e.target.closest("[data-trigger]");

      if (trigger) {
        const quantityElement =
          this.querySelector("[name='quantity']");

        const currentQuantity = quantityElement
          ? parseInt(quantityElement.value)
          : 1;

        switch (trigger.dataset.trigger) {
          case "quantity-decrease":
            if (
              !this.isLoading &&
              !trigger.classList.contains("disabled") &&
              currentQuantity > 1
            ) {
              quantityElement.value =
                currentQuantity - 1;

              this.querySelector(
                '[data-trigger="quantity-decrease"]'
              )?.classList.toggle(
                "disabled",
                currentQuantity - 1 <= 1
              );

              this.querySelector(
                '[data-trigger="quantity-increase"]'
              )?.classList.remove("disabled");
            }
            break;

          case "quantity-increase":
            if (
              !this.isLoading &&
              !trigger.classList.contains("disabled") &&
              currentQuantity < 99
            ) {
              quantityElement.value =
                currentQuantity + 1;

              this.querySelector(
                '[data-trigger="quantity-decrease"]'
              )?.classList.remove("disabled");

              this.querySelector(
                '[data-trigger="quantity-increase"]'
              )?.classList.toggle(
                "disabled",
                currentQuantity + 1 >= 99
              );
            }
            break;

          case "select-media":
            if (!this.slider) break;

            const targetSlide =
              this.slider.querySelector(
                `[data-slide="${trigger.dataset.slide}"]`
              );

            if (targetSlide) {
              // Only move the horizontal product slider.
              // Do not use scrollIntoView because it can
              // move the entire page vertically.
              this.slider.scrollTo({
                left: targetSlide.offsetLeft,
                behavior: "smooth",
              });

              requestAnimationFrame(() => {
                this.updateScrollbar();
              });
            }
            break;

          case "disclosure": {
            const tab =
              trigger.closest("[data-disclosure]");

            if (!tab) break;

            const disclosureContent =
              tab.querySelector(
                ".maolis-product__disclosure-content"
              );

            if (!disclosureContent) break;

            const wasOpen =
              tab.classList.contains("open");

            this.querySelectorAll(
              "[data-disclosure].open"
            ).forEach((openTab) => {
              if (openTab !== tab) {
                openTab.classList.remove("open");

                const openContent =
                  openTab.querySelector(
                    ".maolis-product__disclosure-content"
                  );

                if (openContent) {
                  openContent.style.maxHeight = null;
                }
              }
            });

            tab.classList.toggle("open", !wasOpen);

            disclosureContent.style.maxHeight =
              !wasOpen
                ? disclosureContent.scrollHeight + "px"
                : null;

            break;
          }
        }

        return;
      }

      const control =
        e.target.closest("[data-control]");

      if (!control || !this.slider || !this.slides.length) {
        return;
      }

      const blockWidth =
        this.slides[0].offsetWidth + 8;

      let newScrollLeft =
        this.slider.scrollLeft;

      if (control.dataset.control === "next") {
        newScrollLeft += blockWidth;
      }

      if (control.dataset.control === "prev") {
        newScrollLeft -= blockWidth;
      }

      this.slider.scrollTo({
        left: newScrollLeft,
        behavior: "smooth",
      });

      requestAnimationFrame(() => {
        clearTimeout(this.scrollEndTimer);

        this.scrollEndTimer = setTimeout(() => {
          this.updateScrollbar();
        }, 300);
      });
    });
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;

    this.classList.toggle(
      "loading",
      this.isLoading
    );
  }
}

customElements.define(
  "maolis-product",
  MaolisProduct
);